import { useAuth } from "../../context/authContext";
// CiCoEntry.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const CiCoEntry = ({ quote }) => {
  const { loginUser } = useAuth();

  const [entryText, setEntryText] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  
  const site_name = storedUser?.offices || "";

  const userName = loginUser;

  const [history] = useState(["CI", "CO"]);

  const handleGo = async () => {
    const [typeRaw, ...locationParts] = entryText.trim().split(" ");
    const type = typeRaw?.toUpperCase();

    const location = locationParts.join(" ");

    if (!["CI", "CO"].includes(type) || !location) {
      setMessage("Please enter in format: CI <siteName> or CO <siteName>");
      return;
    }
    // if (!type) {
    //   setMessage("Please enter in format: CI or CO");
    //   return;
    // }

    // if (!["CI", "CO"].includes(type) || !location) {
    //   setMessage("Please enter in format: CI <siteName> or CO <siteName>");
    //   return;
    // }

    setLoading(true);
    const timestamp = moment().format("YYYY-MM-DD h:mmA");
    try {
      const response = await axios.post(`${API_URL}/api/attendance/manual`, {
        empName: userName,
        timestamp,
        entryText: entryText.trim().toUpperCase(),
      });
      setMessage(response.data.message);
      setEntryText(""); // Clear input on success

      toast.success("Entry saved successfully!");
    } catch (err) {
      if (err.status === 404) {
        const message = err.response.data.message;
        toast.warn(`${message}`);
        return;
      }

      if (err.status === 409) {
        const timeStamp = err.response.data.timestamp;
        toast.warn(`CI already recorded at ${timeStamp}. Please enter CO`);
        return;
      }

      const errorMsg = err.response?.data?.error || "Error processing entry";
      setMessage(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };
  const handleChipClick = (cmd) => {
    setEntryText(cmd + " " + site_name);
  };
 
const formatWFHDataForToast = (data) => {
  if (!data || data.length === 0) {
    return <div>No pending WFH requests</div>;
  }

  // Group data by Name
  const groupedByPerson = data.reduce((acc, item) => {
    if (!acc[item.Name]) {
      acc[item.Name] = [];
    }
    acc[item.Name].push({
      month: item.month_name,
      count: item.wfh_count
    });
    return acc;
  }, {});

  // Month sorting order
  const monthOrder = {
    'January': 1, 'February': 2, 'March': 3, 'April': 4,
    'May': 5, 'June': 6, 'July': 7, 'August': 8,
    'September': 9, 'October': 10, 'November': 11, 'December': 12
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif' }}>
      <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '12px', color: '#1a73e8' }}>
        📋 Pending WFH Approvals
      </div>
      {Object.entries(groupedByPerson).map(([name, months]) => {
        months.sort((a, b) => monthOrder[a.month] - monthOrder[b.month]);
        
        return (
          <div key={name} style={{ marginBottom: '12px' }}>
            <div style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '4px' }}>
              👤 {name.trim()}
            </div>
            <div style={{ paddingLeft: '20px', color: '#555', fontSize: '13px' }}>
              {months.map((m, idx) => (
                <span key={idx}>
                  {m.month}: {m.count} day{m.count > 1 ? 's' : ''}
                  {idx < months.length - 1 ? ' • ' : ''}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const fetchPendingApproval = async() => {
  try {
    const response = await axios.get(`${API_URL}/api/attendance/pending-req-wfh?employeeId=${storedUser.employeeId}`);
    if (response.data && response.data.length > 0) {
      const toastContent = formatWFHDataForToast(response.data);
      toast.info(toastContent, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    console.log(response, storedUser)
  } catch (err) {
    if (err.status === 404) {
      const message = err.response.data.message;
      toast.warn(`${message}`);
      return;
    }
    const errorMsg = err.response?.data?.error || "Error processing entry";
    setMessage(errorMsg);
    toast.error(errorMsg);
  } finally {
    setLoading(false);
  }
}

  useEffect(()=>{
    fetchPendingApproval()
  },[])

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f0f2f8" }}>
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Quote marquee */}
      <div className="quote-marquee bg-white text-primary py-1" style={{ borderBottom: "1px solid #e8eaed" }}>
        <div className="marquee-content">
          <span className="quote-text">
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {quote.content}
            </span>
            {quote.author && (
              <span className="fw-bold author-badge author-name ms-2">
                — {quote.author}
              </span>
            )}
          </span>
        </div>
      </div>

      {/* ── Attendance card ── */}
      <div style={{ display: "flex", justifyContent: "center", padding: "clamp(24px, 5vw, 48px) 16px 24px" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
            padding: "clamp(24px, 4vw, 40px) clamp(20px, 5vw, 48px)",
            width: "100%",
            maxWidth: "420px",
          }}
        >
          <h5 style={{ textAlign: "center", fontWeight: 700, color: "#1e293b", marginBottom: "20px" }}>
            Mark Attendance
          </h5>

          {/* CI / CO chip buttons */}
          <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginBottom: "20px" }}>
            {history.map((cmd) => (
              <button
                key={cmd}
                onClick={() => handleChipClick(cmd)}
                style={{
                  padding: "6px 22px",
                  borderRadius: "20px",
                  border: "1.5px solid #c7d2fe",
                  background: entryText.startsWith(cmd) ? "#e0e7ff" : "#f8faff",
                  color: "#4f46e5",
                  fontWeight: 600,
                  fontSize: "14px",
                  cursor: "pointer",
                  transition: "all 0.15s",
                }}
              >
                {cmd}
              </button>
            ))}
          </div>

          {/* Text input */}
          <input
            type="text"
            placeholder='Type "CI" or "CO"'
            value={entryText}
            onChange={(e) => setEntryText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !loading && handleGo()}
            style={{
              width: "100%",
              padding: "11px 14px",
              border: "1.5px solid #e2e8f0",
              borderRadius: "10px",
              fontSize: "15px",
              outline: "none",
              boxSizing: "border-box",
              marginBottom: "16px",
              color: "#1e293b",
              background: "#f8fafc",
              transition: "border-color 0.2s",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#6366f1")}
            onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
          />

          {/* Submit button */}
          <button
            onClick={handleGo}
            disabled={loading}
            style={{
              width: "100%",
              padding: "12px",
              background: loading ? "#a5b4fc" : "#4f46e5",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              fontSize: "15px",
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background 0.2s",
              letterSpacing: "0.3px",
            }}
          >
            {loading ? "Processing…" : "Submit"}
          </button>

          {message && (
            <p style={{ marginTop: "12px", textAlign: "center", color: "#475569", fontSize: "13px" }}>
              {message}
            </p>
          )}
        </div>
      </div>

      {/* ── Protovec logo ── */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img src="/protoveclogo.png" alt="Protovec" style={{ height: "48px", width: "auto", objectFit: "contain" }} />
      </div>

      {/* ── Mission / Vision cards ── */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          padding: "0 16px 40px",
        }}
      >
        <div className="card1">
          <h3 className="mission-title">🎯 Mission</h3>
          <div className="card-content">
            <p className="text m-0 mt-2">
              To provide right fit intuitive solutions using minimalist approach to help customers progress
              towards higher efficiency, better quality and reduced costs. To help employees better their
              performance, achieve greater heights and lead a blissful life.
            </p>
          </div>
        </div>
        <div className="card1">
          <h3 className="vision-title">💡 Vision</h3>
          <div className="card-content">
            <p className="text m-0 mt-2">
              To be a global leader in offering simple yet efficient automation solutions, empowering
              businesses for sustainable growth while fostering a harmonious co-existence.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CiCoEntry;
